module.exports = __webpack_public_path__ + "img/636901620374640357.ca88fc1c.gif";